import { ChangeDetectorRef, Injectable, NgZone } from '@angular/core';
import { AlertController, ToastController, LoadingController, ModalController, Platform, IonicSafeString } from '@ionic/angular';
import { VideoPlayerComponent } from '../components/modals/video-player/video-player.component';
import { SocialSharing } from '@ionic-native/social-sharing/ngx';
import { File } from '@ionic-native/file/ngx';
import { HTTP } from '@ionic-native/http/ngx';
import { AndroidPermissions } from '@ionic-native/android-permissions/ngx';
import { BehaviorSubject } from 'rxjs';
import { SuaLetterService } from './sua-letter.service';

import { NavigationExtras, Router } from '@angular/router';
import { ImageViewComponent } from '../components/modals/image-view/image-view.component';
import { FileOpener } from '@ionic-native/file-opener/ngx';

@Injectable({
  providedIn: 'root'
})
export class AlertService {
  loading: boolean = false;

  hasErr: any = false
  errorMsg = new BehaviorSubject("");
  errorExist = new BehaviorSubject(false);
  interval: any

  constructor( private router:Router,private androidPermissions: AndroidPermissions,private nativeHTTP: HTTP,private loadingCtrl:LoadingController,private toastController: ToastController,private alertController:AlertController,private modalController:ModalController, private socialSharing : SocialSharing, private file: File,  public platform: Platform,
    private suaLetterService:SuaLetterService,  private fileOpener: FileOpener
 ) { }
  
  async presentToast(message: any) {
    const toast = await this.toastController.create({
      message: message,
      duration: 2000,
      position: 'top',
      color: 'dark'
    });
    toast.present();
  }
  async presentToastError(message: any) {
    const toast = await this.toastController.create({
      message: message,
      duration: 4000,
      position: 'top',
      color: 'danger'
    });
    toast.present();
  }
  async presentAlert(header: string, message: string) {
    const alert = await this.alertController.create({
      header,
      message,
      buttons: ['OK']
    });

    await alert.present();
  }
  async presentLoading(m?: string) {
    this.loading = true;
    return await this.loadingCtrl.create({
      message: m,
    }).then(a => {
      a.present().then(() => {
        if (!this.loading) {
          a.dismiss().then(() => console.log());
        }
      });
    });
  }
  async dismissLoading() {
    this.loading = false;
    return await this.loadingCtrl.dismiss().then(() => console.log('dismissed'));
  }
  isFileVideo(path: string): boolean {
    const ext = path.endsWith('.mp4') || path.endsWith('.MOV') || path.endsWith('.webm');
    return ext
  }
  isFilePdf(path: string): boolean {
    const ext = path.substr(path.length - 4, path.length);
    return ext === '.pdf' ? true : false;
  }
  isFileExcel(path: string): boolean {
    const ext = path.endsWith('.xlsx') || path.endsWith('.xls');
    return ext
  }
  isFileWord(path: string): boolean {
    const ext = path.endsWith('.docx') || path.endsWith('.doc');
    return ext
  }
  isFilePowerPoint(path: string): boolean {
    const ext = path.endsWith('.ppt') || path.endsWith('.pptx');
    return ext
  }
  isFileImage(path: string): boolean {
    let lowerPath = path.toLocaleLowerCase()
    const ext = lowerPath.endsWith('.jpg') || lowerPath.endsWith('.jpeg') || lowerPath.endsWith('.png');
    return ext
  }
  isFileTxt(path: string): boolean {
    const ext = path.endsWith('.txt')
    return ext
  }
  isFileAudio(path: string): boolean {
     const ext = path.endsWith('.mp3') || path.endsWith('.aac') || path.endsWith('.wav') || path.endsWith('.flac') || path.endsWith('.m4a')
    return ext
  }

 getAudioType(fileName: string): string {
  const extension = fileName.split('.').pop().toLowerCase();
  switch (extension) {
    case 'mp3':
      return 'audio/mpeg';
    case 'aac':
      return 'audio/aac';
    case 'wav':
      return 'audio/wav';
    case 'flac':
      return 'audio/flac';
    case 'm4a':
      return 'audio/mp4';
    default:
      return 'audio/wav';
  }
  }

  async openVideoPlayer(path_video:string,title_video?:string){
    let modal= await this.modalController.create({
      component:VideoPlayerComponent,
      componentProps:{
        path_video,
        title_video
      }
    });
    modal.present();
  }

  async downloadFile(url, name) {
    if (!this.platform.is('cordova')) {
      window.open(url, '_system');
      return
    }
    this.presentLoading();
    let path = await this.getDownloadPath()
    let final_path = path + name;
    this.nativeHTTP.downloadFile(encodeURI(url), {}, {}, encodeURI(final_path)).then(response => {
      this.dismissLoading();
      console.log('success', JSON.stringify(response));
      let mimeType = ''
      if (this.isFileExcel(url)) mimeType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      else if (this.isFilePdf(url)) mimeType = 'application/pdf'
      else if (this.isFileWord(url)) mimeType = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
      else if (this.isFilePowerPoint(url)) mimeType = 'application/vnd.openxmlformats-officedocument.presentationml.presentation'
      else if (this.isFileTxt(url)) mimeType = 'text/plain'
      else mimeType = 'image/' + this.getExtFromUrl(url)

      this.fileOpener.open(response.nativeURL, mimeType)
        .then(() => console.log("File is opened"))
        .catch(e => this.presentToastError('File opener Error status: ' + e.status + ' - Error message: ' + e.message));

    }).catch(err => {
      this.dismissLoading();
      console.log('error block ... ', err.status);
      console.log('error block ... ', err.error);
    })
  }
  async downloadShare(url, name) {
    if (!this.platform.is('cordova')) {
      return
    }
    this.presentLoading();
    let path = await this.getDownloadPath()
    let final_path = path + name;
    this.nativeHTTP.downloadFile(encodeURI(url), {}, {}, encodeURI(final_path)).then(response => {
      this.dismissLoading();
      console.log('success block...', JSON.stringify(response));
      this.socialSharing.share(null, null, response.nativeURL, null).then((data) => {
        console.log('Shared via SharePicker');
      }).catch((err) => {
        console.log('Was not shared via SharePicker', JSON.stringify(err))
      });
    }).catch(err => {
      this.dismissLoading();
      console.log('error block ... ', err.status);
      console.log('error block ... ', err.error);
    })
  }
  async getDownloadPath() {
    if (this.platform.is('ios')) {
      return this.file.documentsDirectory;
    }
    await this.androidPermissions.checkPermission(this.androidPermissions.PERMISSION.WRITE_EXTERNAL_STORAGE).then(
      result => {
        if (!result.hasPermission) {
          return this.androidPermissions.requestPermission(this.androidPermissions.PERMISSION.WRITE_EXTERNAL_STORAGE);
        }
      }
    );
    return this.file.externalRootDirectory + "/Download/";
  }
  setErrMessage(msg: string) {
    this.errorMsg.next(msg);
  }
  setExistError(msg: boolean) {
    this.errorExist.next(msg);
  }
  getDifferenceInDays(date) {
    let date1 = new Date()
    let date2 = new Date(date)
    let difference_In_Time = date1.getTime() - date2.getTime();
    console.log('days difference', Math.abs(Math.round(difference_In_Time / (1000 * 3600 * 24)) - 1))
    return Math.abs(Math.round(difference_In_Time / (1000 * 3600 * 24)) - 1);
  }
  openFile(data) {
    if (this.platform.is('cordova'))
      this.suaLetterService.createpdf(data.pdf_string, 'Carta SUA', data.id)
    else {
      this.suaLetterService.readSuaLetter(data.id);
      var contentType = "application/pdf";
      var dataBlob = this.suaLetterService.convertBase64ToBlob(data.pdf_string, contentType);
      window.open(URL.createObjectURL(dataBlob), '_system');
    }
  }
  async presentAlertCustom(header, message) {

    const alert = await this.alertController.create({
      cssClass: 'custom-alert',
      backdropDismiss: false,
      header,
      keyboardClose: false,
      subHeader: message,
      message: `<ion-row class="spinner"><ion-spinner></ion-spinner></ion-row>`,
      buttons: [
        {
          text: 'Cancelar',
          role: 'cancel',
          cssClass: 'secondary',
          handler: () => { },
        },
        {
          text: 'Aceptar',
          handler: async () => {

          },
        },
      ],
    });
    await alert.present();


  }
  async closeAlertCustom() {
    return await this.alertController.dismiss().then(() => console.log('dismissed'));
  }


  async toastCustom(msg, type) {
    let icon = `assets/imgs/capacitations/check-${type}.svg`
    const alert = await this.alertController.create({
      cssClass: `custom-alert ${type}`,
      backdropDismiss: false,
      keyboardClose: false,
      message: `<ion-row class="row-toast"><p class="msg"><ion-icon class="icon-toast" src="${icon}"></ion-icon>${msg}</p></ion-row>`,
      buttons: [

      ],
    });
    setTimeout(() => {
      this.closeAlertCustom()
    }, 2000)
    await alert.present();

  }
  sumDaysToDate(date, days) {
    const todayDate = new Date(date);
    const newDate = new Date(todayDate.getTime() + days * 24 * 60 * 60 * 1000);
    let month = newDate.toISOString().split('T')[0].split('-')[1];
    return newDate.getDate() + '/' + month + '/' + newDate.getFullYear();

  }
  createpdf(base64: any, name: string, type: string) {
    if (!this.platform.is('cordova')) {
      var dataBlob = this.convertBase64ToBlob(base64, type);
      window.open(URL.createObjectURL(dataBlob), '_system');
      return
    }
    const writeDirectory = this.platform.is('ios') ? this.file.dataDirectory : this.file.externalDataDirectory;
    this.file.writeFile(writeDirectory, name, this.convertBase64ToBlob(base64, type), { replace: true })
      .then((value) => {
        console.log('==> VALUIE', value);
        this.fileOpener.open(`${writeDirectory}${name}`, type)
          .then(() => console.log('File is opened'))
          .catch(e => console.log('Error opening file', JSON.stringify(e)));
      })
      .catch(() => {
        console.error('Error writing pdf file');
      });
  }
  convertBase64ToBlob(b64Data, contentType): Blob {
    contentType = contentType || '';
    const sliceSize = 512;
    b64Data = b64Data.replace(/^[^,]+,/, '');
    b64Data = b64Data.replace(/\s/g, '');
    const byteCharacters = window.atob(b64Data);
    const byteArrays = [];
    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);
      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }
    return new Blob(byteArrays, { type: contentType });
  }
  async openImageView(path: string, title?: string) {
    let modal = await this.modalController.create({
      component: ImageViewComponent,
      componentProps: {
        path,
        title
      }
    });
    modal.present();
  }
  startTimerOTP(duration, display, func: () => void, message: string,) {
    console.log('enter')
    let seconds;
    let currentSeconds = duration.toString()
    this.interval = setInterval(() => {
      seconds = parseInt((duration % 60).toString(), 10);
      seconds = seconds < 10 ? "0" + seconds : seconds;

      display.innerText = message.replace(currentSeconds, seconds)

      if (--duration < 0) {

        duration = 0;
        clearInterval(this.interval)
        func()
      }
    }, 1000);
  }
  emptyInterval() {
    clearInterval(this.interval)
  }
  getExtFromUrl(url) {
    const parts = url.split('.');
    if (parts.length > 1) {
      return parts.pop();
    }
    return '';
  }
  async blobToBase64(blob) {
  return new Promise((resolve, _) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result);
    reader.readAsDataURL(blob);
  });
}
}
